var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "club-price-pretty-details d-flex flex-column gr-1",
      attrs: { "data-qa": "club_price_pretty_details" },
    },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "text-h6 text--text",
            attrs: { "data-qa": "club_price_pretty_details_online_price" },
          },
          [_vm._v("\n      " + _vm._s(_setup.priceList.online) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "text-h6 text-secondary--text",
            attrs: { "data-qa": "club_price_pretty_details_lpu_price" },
          },
          [_vm._v("\n      " + _vm._s(_setup.priceList.lpu) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
          _vm._v("\n      Опцион на скидку\n      "),
          _vm.isNoCard && _vm.cardPrice
            ? _c(
                "div",
                {
                  attrs: {
                    "data-qa": "club_price_pretty_details_with_card_text",
                  },
                },
                [_vm._v("\n        + доступ к клубу\n      ")]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
          _vm._v("\n      Оплата приёма\n    "),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "mt-1" }, [
      _c("div", { staticClass: "py-1 bg-club-gradient rounded-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "py-1 bg-club rounded-sm" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [
      _c("div", { staticClass: "text-body-2 text-warning--text" }, [
        _vm._v("\n      Покупка онлайн\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
        _vm._v("\n      В клинике\n    "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }